import publicApi from '../../services/publicApi';

/**
 * The three endpoints a recipient reaches without an account. They all go
 * through `publicApi`, which carries no session — see the note there.
 */

/**
 * Searches a customer's own orders.
 *
 * The backend takes either a reference plus the phone that bought with it, or a
 * phone on its own, or an order id. It answers with the five most recent
 * matches, never more.
 *
 * @param {{idReference?: string, phone?: string, orderId?: string}} payload
 */
export const searchOrdersRequest = (payload) => {
  return publicApi.post('exposed_api/tracking/', payload);
};

/**
 * The same search for a partner's own customers: the reference is scoped to
 * that partner's admin instead of being paired with a phone.
 *
 * @param {{idReference: string, idAdmin: number}} payload
 */
export const searchPartnerOrdersRequest = (payload) => {
  return publicApi.post('exposed_api/globaltracking/tracking/', payload);
};

/**
 * One order with its full status history.
 *
 * @param {string|number} orderId
 */
export const getTrackedOrderRequest = (orderId) => {
  return publicApi.get(`exposed_api/customer_track_order/${orderId}/`);
};
